var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('account-menu-header'),_c('v-divider'),_c('account-menu-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }